import { render, staticRenderFns } from "./EmployeePieChart.vue?vue&type=template&id=28409208&"
import script from "./EmployeePieChart.vue?vue&type=script&lang=js&"
export * from "./EmployeePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports